module.exports = __webpack_public_path__ + "static/media/07.096ee4b6.jpg";